import { Alert, Container } from 'reactstrap';
import Header from '../header/Header';

const ThankYouPage = () => {

  return (
    <Container>
      <Header />
      <div style={{ padding: 20 }}>
        <Alert fade={false}>
          <strong>ご登録ありがとうございます。</strong><br />
          追って担当者より、メンバーポータルのIDとPASSをメールにてご連絡差し上げます。その後、引き続き必要事項のご入力をお願い申し上げます。<br /><br />
          ご不明な点等ございましたら、下記アドレスまでご連絡ください。<br />
          jactim@jcci.com.my<br /><br /><hr /><br />

          <strong>Thank you for your application.</strong><br />
          JACTIM Secretariat will contact you by email with your Member Portal ID and temporary password.
          Upon logging in to the Member Site, you are required to complete the registration by providing necessary details.<br /><br />
          If you have any questions, please contact the secretariat at the email below:<br />
          jactim@jcci.com.my
        </Alert>
      </div>
    </Container>
  )
}

export default ThankYouPage;